export default "__VITE_ASSET__CsPWDc3G__"